import CMSCacheModule from './CMSCache';

export const gql = String.raw;

const localeMapBy = {
  'pt-BR': 'pt_BR',
  'es-MX': 'es_MX',
  en: 'en',
};

function validateLocale(locale, localeMap = localeMapBy) {
  const hasLocale = Boolean(locale);

  const isValidLocale = localeMap[locale];

  if (hasLocale && isValidLocale) {
    return true;
  }

  throw new Error(`You must provide a valid locale like: ${Object.keys(localeMapBy).join(', ')}`);
}

async function createGraphQLClientModule({ endpointUrl, token }) {
  const { GraphQLClient } = await import('graphql-request');

  const gqlClient = new GraphQLClient(endpointUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return gqlClient;
}

export function CMSGraphQLClient(
  args = {},
  dependencies = {
    CMSCache: CMSCacheModule,
    createGraphQLClient: createGraphQLClientModule,
  },
) {
  const {
    CMSCache,
    createGraphQLClient,
  } = dependencies;

  const defaultArgs = {
    token: process.env.DATO_CMS_TOKEN,
    preview: false,
  };

  const {
    preview,
    token,
  } = { ...defaultArgs, ...args };

  const datoCMSEndpoint = preview
    ? 'https://graphql.datocms.com/preview'
    : 'https://graphql.datocms.com/';

  const cacheLayer = CMSCache();

  return {
    async query({
      query = '',
      variables = {},
      cache = true,
    }) {
      const gqlClient = await createGraphQLClient({ token, endpointUrl: datoCMSEndpoint });
      const hasCacheEnabled = Boolean(cache) && !preview;

      if (hasCacheEnabled && cacheLayer.hasCacheEntryFor(query, { preview, variables })) {
        return {
          data: {
            messages: cacheLayer.queryFromCache(query, { preview, variables }),
          },
        };
      }
      const { locale } = variables;
      try {
        const messages = await gqlClient.request(query, {
          ...variables,
          locale: validateLocale(locale) && localeMapBy[locale],
        });
        cacheLayer.add(query, messages, { preview, variables });

        return {
          data: {
            messages,
          },
          error: undefined,
        };
      } catch (err) {
        throw new Error(err.message);
      }
    },
  };
}
